import { render, staticRenderFns } from "./CostosVentasProductos.vue?vue&type=template&id=f91679ce&"
import script from "./CostosVentasProductos.vue?vue&type=script&lang=js&"
export * from "./CostosVentasProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports